module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAElBMVEVMaXH////////////////////7e1ULAAAABnRSTlMACkW+/lc4LGxBAAAAZklEQVR42uWTwQ0AIQgEAZf+W77oh8dqpoDzBcxEIZGIyIrHqYzNl/rOWysPl/rOtY2S7kYfUCdwY8oTPvkkzi3lAl/JTdFYxs0Y/jCMm2HcjOEk8BPcJI/p/K//AxcHVw+XF9f/A9AUBjVc9tk5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/_img/icon_tanchuang_close.png
// module id = mxV6
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14